import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import {
  formatAccuracy,
  formatNumber,
  formatTime,
} from '../../utils/numberFormatter';

class PracticeExamResults extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      correct: 110,
      correctPoints: 32,
      accuracy: 0, // this is calculated, might wanna do it on the server
      accuracyPoins: 5,
      timeElapsed: '05:54',
      timeElapsedPoins: 4,
    };
  }

  exitExam = () => {
    this.props.setReviewMode(false);
    this.props.setPracticeExam(null);
    this.props.setExamQuestions([]);
    this.props.setResultsSummarized([]);
    history.push('/app/exams');
  };

  reviewAnswers = () => {
    this.props.setReviewMode(true);

    const raw =
      this.props.lastExam?.resultsDetailed ??
      this.props.lastExam?.retakeResultsDetailed ??
      [];

    const detail = Array.isArray(raw)
      ? raw
      : typeof raw === 'string'
        ? (() => {
            try {
              return JSON.parse(raw);
            } catch {
              return [];
            }
          })()
        : [];

    this.props.setResultsSummarized(detail);

    history.push('/app/practice-exam');
  };

  componentDidMount() {
    const accuracy = Math.floor((this.state.correct / 175) * 100);
    this.setState({ accuracy });
  }

  render() {
    const exam = this.props.lastExam;
    return (
      <div className="question-main-body daily20quizresults">
        <div className="question-background">
          <div className="question-wrapper">
            <h4>Practice Exam</h4>
            <h2>Your Results</h2>
          </div>
        </div>
        <div className="gradient-divider" />
        {exam?.resultsSummarized &&
        Object.values(exam.resultsSummarized).length > 0 &&
        exam.resultsSummarized.correctAnswers ? (
          <div className="card-wrapper d-flex justify-content-center flex-wrap">
            <div className="result-card">
              <i className="icon-check" />
              <h5>{`${exam.resultsSummarized.correctAnswers.value}/${exam.resultsSummarized.totalQuestions}`}</h5>
              <p>CORRECT ANSWERS</p>
              <em>
                +{formatNumber(exam.resultsSummarized.correctAnswers.points)}{' '}
                Points
              </em>
            </div>

            <div className="result-card">
              <i className="icon-pie_chart" />
              <h5>{formatAccuracy(exam.resultsSummarized.accuracy.value)}%</h5>
              <p>ACCURACY</p>
              <em>
                +{formatNumber(exam.resultsSummarized.accuracy.points)} Points
              </em>
            </div>

            <div className="result-card">
              <i className="icon-clock" />
              <h5>{formatTime(exam.resultsSummarized.timeElapsed.value)}</h5>
              <p>TIME ELAPSED</p>
              <em>
                +{formatNumber(exam.resultsSummarized.timeElapsed.points)}{' '}
                Points
              </em>
            </div>
          </div>
        ) : (
          <div className="card-wrapper d-flex justify-content-center flex-wrap">
            <h4 className="pt-4 pb-3">
              Oops! Something went wrong trying to get your exam results.
            </h4>
          </div>
        )}
        <div className="card-wrapper d-flex justify-content-center mt-3">
          <Button
            onClick={this.exitExam}
            color="link"
            className="btn-outline-call-to-action mr-3"
          >
            EXIT EXAM
          </Button>
          {exam && (
            <Button onClick={this.reviewAnswers} color="primary">
              REVIEW ANSWERS
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default PracticeExamResults;
